<template>
  <v-container class="mt-n2 table-container">
     <item-list :items="cameras" :itemsPerPage="itemsPerPage" :headers="headers" :bottomText="$t('changed.perPage')"
            @search="searchInput" @sortBy="getSortedBy" :searchLabel="$t('searchHistory')" :title="$t('statistics')">
        <template slot="tfooter">
            <table-footer :key="footerKey" :page="page" ref="tfooter" :rangeDate="range" :status="startDate" :itemSelected="itemsPerPage" :search="search" 
            :tableInfo="this.getCamerasPages" @callback="setRequestInterval" />
        </template>
        </item-list>
        <v-container class="total-container">
        <v-layout class="tables">
            <v-row>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('total')}}</p>
                    <v-simple-table class="simple-table">
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{$t('totalCameras') }}</td>
                                <td class="text-right table-data">{{ total.totalCameras }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('totalHoursOfVideoRequested') }}</td>
                                <td class="text-right table-data">{{ getHours(total.totalHoursRequested) }}</td>
                            </tr>
                            <tr class="gris">
                                <td class="header-table">{{$t('totalHoursOfVideoTaken') }}</td>
                                <td class="text-right table-data">{{ getHours(total.totalHoursExtracted) }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('numberOfExtractions') }}</td>
                                <td class="text-right table-data">{{ total.totalDownloads }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('average')}}</p>
                    <v-simple-table class="simple-table">
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{$t('hoursOfVideoRequested') }}</td>
                                <td class="text-right table-data">{{getHours(total.averageHoursRequested) }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('hoursOfVideoExtracted') }}</td>
                                <td class="text-right table-data">{{ getHours(total.averageHoursExtracted) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-layout>
        

        <p class="min-res">{{$t('minimunResolution')}}</p>
        </v-container>
        
    </v-container>
</template>

<script>
import StatisticsMixin from '@/mixins/StatisticsMixin'
import FilterMixin from '@/mixins/FilterMixin'
export default {
  components:{
    ItemList: ()=> import('@/components/base/ItemList'),
    TableFooter: ()=>import('@/components/base/TableFooter'),
  },
  mixins: [StatisticsMixin, FilterMixin],
  data () {
    return {
      cameras: [],
      sortBy: undefined,
      sortDesc: undefined,
      total: [],
      startDate: '',
      range: 'day',
      pages: 0,
      mapKey:0
    }
  },
  computed : {
    headers: {
      get() {
        return [
          {text: this.$t('cameraName'), value: 'cameraName', sortable: true, align: 'left'},
          {text: this.$t('hoursOfVideoRequested'), value: 'totalHoursRequested', sortable: true},
          {text: this.$t('hoursOfVideoExtracted'), value: 'totalHoursExtracted', sortable: false},
          {text: this.$t('numberOfOrganismsRequesting'), value: 'totalOrganismsRequested', sortable: true},
          {text: this.$t('numberOfExtractions'), value: 'totalDownloads', sortable: true},
        ]
      },
    },
  },
  watch: {
  },
  created(){
    this.startDate = this.$store.getters.getStartDate
      this.range = this.$store.getters.getRange
      this.getData();
    this.footerKey = 0
    this.search = ''
    this.page = 1
    this.mapKey++
  },
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = 0
  },
  async mounted(){
    await this.setRequestInterval()
    await this.getCameraTotal();
    this.footerKey++
  },
  
  methods: {
    getSortedBy(sortBy, desc){
      this.sortBy = sortBy
      this.sortDesc = desc
      this.setRequestInterval(this.page, this.itemsPerPage)
    },
    async setRequestInterval(page=1, itemsPerPage=10){
      this.page=page
      this.itemsPerPage = itemsPerPage
      if(this.interval!==0)
        clearInterval(this.interval)
      await this.getData()
      this.interval = setInterval(this.getData,5000)
    },
    async getData(){
      await this.$extractions.getStatisticsCameras(this.page,this.itemsPerPage,this.search,this.sortBy, this.sortDesc, this.startDate, this.range).then(response=>{
        if(response.data.cameras.length===0){
         if((this.search!=="")&&(this.page===1)){
            this.cameras = []    
          }
          if(this.page>1){
            this.page --
            this.$refs.tfooter.stepBack(this.page)
          }else{
            this.$refs.tfooter.stepBack(1)
          }
        }
        this.cameras = response.data.cameras
        this.pages = response.data.pages
        this.footerKey++
      }).catch(()=>{
        
        return null
      })
    },
    getCameraTotal(){
        this.$extractions.getCameraTotal(this.search, this.startDate, this.range).then(response=>{
            this.total = response.data
        }).catch(e=>{
            console.log('Error: ', e)
        })      
    },
    getHours(duration){

      var minutes = parseInt((duration/(1000*60))%60)
        , hours = parseInt((duration/(1000*60*60))%24)
        , days = parseInt((duration / (1000 * 60 * 60 * 24)))
      hours += days * 24
      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;

      return hours + ":" + minutes + " Hs.";
    },
    getCamerasPages(){
      const self = this  
      return new Promise(function (resolve){
        resolve({data: self.pages});
      }) 
    },
    refreshPage(){
      this.mapKey++
      this.getCameraTotal()
    },
    onRefresh(){
        this.getData()
        this.refreshPage()
    }
  }
  
  
}
</script>
<style>
    
    .title-statistics{
        font-size:18px!important;
        font-family: 'Roboto', 'sans-serif';
        color: #0d5ae5;
    }
    .tables{
        width: 80%;
        margin: 0 auto;
    }
    .simple-table{
        border: 1px solid #ccc;
    }
    .gris:hover{
        background-color: #f8faff!important;
    }
    .gris{
        background-color: #f8faff!important;
    }
    .header-table{
        font-size: 12px!important;
        font-weight: 600!important;
        width: 60%!important;
    }
    .min-res{
        position: absolute!important;
        font-size: 10px!important;
        text-align: right!important;
        bottom: -35px!important;
        right: 0px!important;
    }
    .map-cameras .map{
        height: 500px!important;
        width: 100%!important;
        margin-left: 0!important;
        padding-left: 0!important;
        z-index: 99!important;
       
    }
    .container.map-cameras{
      max-width: 1400px!important;
    }
    @media (max-width: 960px) {
        .map-cameras .map{
          height: 400px!important;
      }
    }
    @media (max-width: 700px) {
        .tables{
            width: 100%!important;
        }
        .table-data{
            font-size: 12px!important;
        }
        .map-cameras .map{
          height: 350px!important;
      }
    }
    @media (max-width: 450px) {
        .total-container{
            margin-left: -20px!important;
        }
    }
</style>